export default ({ request }) => ({
  ecomAmzSkuDocSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/doc/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuDocListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/doc/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuDocDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/doc/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuDocDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/doc/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuDocUploadApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/doc/upload',
      method: 'POST',
      data,
    })
  },
})
